import React from "react";
import { Pressable } from "../../../../../pressable";
import { ParsedText } from "../../utils/ParsedText";

export function Options({
    visibleQuestions,
    selectQuestion,
    startSectionId,
    getLocalization,
    trackButtonClick,
    lastSelectedQuestion,
}: {
    visibleQuestions: Array<{
        text: string;
        sectionId: string;
    }>;
    selectQuestion: (question: { text: string; sectionId: string }) => void;
    startSectionId: string;
    getLocalization: (id: string) => string;
    trackButtonClick: (
        eventId: string,
        label?: string,
        properties?: Record<string, unknown>,
    ) => void;
    lastSelectedQuestion: {
        text: string;
        sectionId: string;
    } | null;
}) {
    const trackSelectOption = (question: {
        text: string;
        sectionId: string;
    }) => {
        trackButtonClick("velvetGlitchSelectOption", undefined, {
            selectedOptionLabel: question.text,
            selectedOptionDestinationSectionId: question.sectionId,
            previousSectionId: lastSelectedQuestion?.sectionId,
            previousSectionLabel: lastSelectedQuestion?.text,
            availableOptions: visibleQuestions.map((q) => ({
                label: q.text,
                destinationSectionId: q.sectionId,
            })),
        });
    };

    if (visibleQuestions.length === 0) {
        return null;
    }

    return (
        <div
            className={`options ${visibleQuestions.length === 1 ? "single-option" : ""}`}
        >
            {visibleQuestions.map((question, index) => {
                return (
                    <Pressable key={index}>
                        <div
                            className="option"
                            onClick={() => {
                                selectQuestion(question);
                                trackSelectOption(question);
                            }}
                        >
                            {question.sectionId === startSectionId ? (
                                getLocalization(
                                    "globalText.langVelvetGlitchBackToStart",
                                )
                            ) : (
                                <ParsedText>{question.text}</ParsedText>
                            )}
                        </div>
                    </Pressable>
                );
            })}
        </div>
    );
}
